import { createContext } from "react";

const AccountsContext = createContext({} as any);

export default AccountsContext;